<script>
import { mapGetters } from 'vuex';
import googleAdsAPI from 'dashboard/api/googleAds';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: { Spinner },
  computed: {
    ...mapGetters({ accountId: 'getCurrentAccountId' }),
  },
  mounted() {
    this.handleCallback();
  },
  methods: {
    async handleCallback() {
      const { code, state } = this.$route.query;
      if (!code) {
        this.finish(false);
        return;
      }
      // O account não está na URL do popup; vem do state do OAuth ("accountId:userId").
      const accountId = this.accountIdFromState(state) || this.accountId;
      try {
        await googleAdsAPI.callback(code, accountId);
        this.finish(true);
      } catch {
        this.finish(false);
      }
    },
    accountIdFromState(state) {
      if (!state) return null;
      try {
        const normalized = state.replace(/-/g, '+').replace(/_/g, '/');
        return atob(normalized).split(':')[0];
      } catch {
        return null;
      }
    },
    finish(connected) {
      if (window.opener) {
        window.opener.postMessage(
          { type: 'google-ads-oauth', connected },
          window.location.origin
        );
        window.close();
      } else {
        this.$router.push({
          name: 'settings_integrations_google_ads',
          params: { accountId: this.accountId },
        });
      }
    },
  },
};
</script>

<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <Spinner size="large" />
      <p class="mt-4 text-n-slate-11">
        {{ $t('INTEGRATION_SETTINGS.GOOGLE_ADS.CONNECTING') }}
      </p>
    </div>
  </div>
</template>
